import React from 'react';
import styles from './FooterChannels.module.scss';

type FooterChannelsProps = {
  children: React.ReactNode | React.ReactNode[];
};

export const FooterChannels = ({ children }: FooterChannelsProps) => <div className={styles.root}>{children}</div>;
